'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import { getProduct } from '../api/products';
import productPage from '../product/product-page';
import util from '../util';
import Promise from 'bluebird';
import each from 'lodash/each';
import values from 'lodash/values';
import getToken from '../api/token';
import checkoutShipping from '../checkout/shipping';
import alert from '../ui/alert';
import {slideDown, slideUp} from '../ui/slide';
import {openModal, closeModal} from '../ui/modal';

Promise.config({cancellation: true});

export default API => {
	/**
   * @param {String|jQuery} selector
   */
	API.productReturnForm = ({ container = '.form-return-products', order = {} } = {}) => {
		const _$container = $(container);
		if (!_$container.length) return;

		const $activeSection = _$container
			.find('.card-header > .button:not(.collapsed)')
			.first()
			.closest('.card')
			.find('.collapse');

		const showMessage = alert($activeSection);

		const templates = {
			product: $('#mustache-product-card').html(),
			summary: $('#mustache-club-return-products-summary').html(),
			address: $('#mustache-address-form').html(),
			deliveryMethods: $('¤mustache-delivery-methods').html()
		};

		const _state = {
			// selected colors and sizes
			selected: {},
			// product cache
			products: {},
			// returned and swapped products
			summary: {}
		};

		let _request;

		/**
		 *
		 * @param {String} productId
		 */
		const findProduct = (itemId) => _$container.find(`.product[data-item-id="${itemId}"]`);

		/**
     *
     * @param {String} itemId
     */
		const renderSelected = itemId => {
			const props = _state.selected[itemId];
			const $textArea = findProduct(itemId).find('.selected-product-info');
			if (props) {
				let text = ['color', 'size'].map(prop => props[prop]).filter(Boolean).join(', ');
				if (text) {
					text = ` tuotteeseen <strong>${text}</strong>`;
				}
				$textArea.html(text);
			} else {
				$textArea.html('');
			}
		}

		/**
     *
     * @param {String} itemId
     * @param {String} prop
     * @param {String} value
     */
		const updateSelectedProp = (itemId, prop, value) => {
			_state.selected[itemId] = _state.selected[itemId] || {};
			if (value) {
				_state.selected[itemId][prop] = value;
			} else {
				delete _state.selected[itemId][prop];
			}
			renderSelected(itemId);
		}

		/**
     *
     * @param {String} productId
     */
		const clearSelected = (itemId) =>
			findProduct(itemId).find('.selected-product-info').html('');

		const showSwapDisclaimer = ($product) =>
			$product.find('.product-swap-disclaimer').removeClass('hidden');

		const hideSwapDisclaimer = ($product) =>
			$product.find('.product-swap-disclaimer').addClass('hidden').find('textarea').val('');


		/**
     * @param {jQuery} $product
     * @param {Object} product
     */
		const renderProductCard = ($product, product) => {
			const {itemId, ean} = $product.data();
			const $container = $product.find('.product-swap-container');
			product.allColorImages.forEach(image => {
				delete image.current;
			});
			if (!product.availableInWeb) {
				$('<div/>').text('Valitettavasti tuote on myyty loppuun kaikkien värien ja kokojen osalta. Vain palautus on mahdollista tällä hetkellä').insertAfter($container);
			}
			const markup = Mustache.render(templates.product, {...product, itemId, hideGallery: true});
			$container.removeClass('hidden').html(markup);

			if (product.notFound || !product.availableInWeb) {
				$product.find('[name^="return_options"][value="refund"]').prop('checked', true).trigger('change');
				$product.find('[name^="return_options"][value="swap"]').prop('disabled', true).closest('.styled-radio').addClass('disabled');
			}
			if (!product.availableInWeb) {
				return false;
			}
			if (product.sap_titlenumber) {
				const $productCard = $container.find('.v4-product-card');
				productPage($productCard, {skipSizeUpdate: true, hideGallery: true});

				// check if product is one size
				const isOneSize = _state.products?.[product.sap_titlenumber]?.isOneSize ?? false;

				$(window).trigger('resize');
				$productCard
					.on('selectColor', (e, color) => {
						updateSelectedProp(itemId, 'color', color);
						updateSelectedProp(itemId, 'size', null);

						if (isOneSize) {
							const colorCode = $productCard.find(`[data-name=${color}]`).val();
							$productCard.find(`[data-color=${colorCode}]`).find('input').prop('checked', true);
						} else {
							hideSwapDisclaimer($product);
							$productCard.find('[name*="ean"]').prop('checked', false);
						}
					})
					.on('selectSize', (e, data) => {
						if (!isOneSize) updateSelectedProp(itemId, 'size', data.size);
						if (ean === data.ean) {
							showSwapDisclaimer($product);
						} else {
							hideSwapDisclaimer($product);
						}
					});
			}
			return slideDown($container);
		}

		/**
     * @param {String} productId
     */
		const getProductData = (productId) => {
			if (_state.products[productId]) {
				return Promise.resolve(_state.products[productId]);
			}
			return getProduct(productId, {warehouse: ['ABAKUS']}).then(({product}) => {
				if (product) {
					_state.products[productId] = product;
				}
				return product;
			});
		}

		/**
     * @param {jQuery} $product
     */
		const openProductCard = ($product) => {
			const $productContainer = $product.find('.product-swap-container');
			const {productId, itemId, color} = $product.data();
			let $loader;
			if (!_state.products[productId]) {
				$loader = util.addFormLoader($productContainer, {align: 'before'});
			}
			_request = getProductData(productId)
				.tap(product => renderProductCard($product, product))
				.tap(() => renderSelected(itemId))
				.tap(() => {
					$('#product-color-'+itemId+'-'+color).trigger('click');
				})
				.catch(err => {
					API.log.error(err);
					const view = {};
					if (err.status === 404) {
						view.notFound = true;
					} else {
						view.error = true;
					}
					return renderProductCard($product, view);
				})
				.finally(() => $loader ? $loader.done() : true);
			return _request;
		}

		/**
     *
     * @param {jQuery} $product
     */
		const closeProductCard = ($product) => {
			const $productContainer = $product.find('.product-swap-container');
			slideUp($productContainer).then($el => $el.html(''));
			const {itemId} = $product.data();
			clearSelected(itemId);
			delete _state.selected[itemId];
		}

		/**
     * @param {Object} state
     */
		const updateSummary = (newState) => {
			each(newState, (action, itemId) => {
				if (action === 'cancel') {
					delete _state.summary[itemId];
				} else {
					_state.summary[itemId] = action;
				}
			});

			const view = values(_state.summary).reduce((data, action) => {
				if (!data[action]) data[action] = true;
				return data;
			}, {order});

			const $container = Object.keys(_state.summary).reduce(($summaries, itemId) => {
				const $summary = $(`[data-item-id="${itemId}"]`).closest('.table-view').find('.return-products-summary');
				return $summaries.add($summary);
			}, $());

			view.canSubmit = view.swap || view.refund;
			view.accountNoRequired = _$container.data('auto-refund') === 0;
			view.isAdminForm = _$container.data('admin-form') === 1;
			view.canSwap = _$container.data('mode') === 'swap-return';
			const markup = Mustache.render(templates.summary, view, {
				deliveryAddress: templates.address
			});
			$container.html(markup);
			const $wrapper = $('.return-products-summary-wrapper');
			if (view.swap || view.refund) {
				$wrapper.removeClass('hidden');
			} else {
				$wrapper.addClass('hidden');
			}
			if (view.swap) {
				checkoutShipping('.delivery-address-form');
			}
		}

		const {formMessages} = _$container.data();
		if (formMessages) {
			formMessages.forEach(showMessage);
		}

		_$container.on('change', '.product-toggle-return', e => {
			const $options = $(e.target).closest('.product').find('.product-return-options');
			const $product = $options.closest('.product');
			const {itemId} = $product.data();
			if ($(e.target).is(':checked')) {
				slideDown($options);
				const $selectedOption = $options.find('[name^="return_option"]:checked');
				if (!$selectedOption.length) {
					$options.find('[value="refund"]:not(:disabled)').prop('checked', true).change();
				} else {
					updateSummary({[itemId]: $selectedOption.val()});
					if ($selectedOption.val() === 'swap') {
						openProductCard($product);
					}
				}
			} else {
				slideUp($options);
				closeProductCard($product);
				updateSummary({[itemId]: 'cancel'});
				updateSelectedProp(itemId, 'color', null);
				updateSelectedProp(itemId, 'size', null);
			}
		});

		_$container.on('change', '[name^="return_option"]', e => {
			const $input = $(e.target);
			let action = $input.val();
			if ($input.attr('type') === 'checkbox') {
				const $return = $input.siblings('[name^="return"]');
				if ($input.is(':checked')) {
					$return.prop('checked', true);
				} else {
					action = 'cancel';
					$return.prop('checked', false);
				}
			}
			const $product = $input.closest('.product');
			const {itemId} = $product.data();
			switch (action) {
				case 'swap':
					updateSummary({[itemId]: 'swap'});
					openProductCard($product);
					break;
				case 'refund':
					updateSummary({[itemId]: 'refund'});
					if ($product.find('.product-details-container').length) {
						closeProductCard($product);
					}
					break;
				default:
					updateSummary({[itemId]: 'cancel'});
					break;
			}
		});

		_$container.on('change', '[name="delivery_address"]', function(e) {
			const $addressForm = _$container.find('.delivery-address-form');
			if ($(this).val() === 1 || $(this).val() === '1') {
				$addressForm.removeClass('hidden');
				$('.selected-pickup-location').addClass('hidden');
			} else {
				$addressForm.addClass('hidden');
				$('.selected-pickup-location').removeClass('hidden');
			}
		});

		$('body')
			.on('click', '.product-return-confirm', e => {
				e.preventDefault();
				_$container.submit();
			})
			.on('click', '.product-return-cancel', e => {
				closeModal();
			});

		_$container.on('submit', function(e) {
			const $form = $(this);
			if (!$('.product-return-confirm:visible').length) {
				e.preventDefault();
				openModal(_$container.find('.product-return-submit'), {compact: true});
			}
			const $token = $form.find('input[name="token"]');
			if (!$token.val()) {
				e.preventDefault();
				return getToken()
					.then(token => $token.val(token))
					.tap(() => $form.submit())
					.tap(() => $token.val(''));
			}
		});
	}

}
